
// 外部依赖
import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
// api
import { getSubject, getStage, getGrade } from '@/api/education';
import { getOrgInfoByOId } from '@/api/login';
// types
import { isArray } from '@/utils/validate';
// 业务信息
import { IService, serviceList, serviceByToolList } from '@/business/ServiceContent';
@Component({
  components: {}
})
export default class Service extends Vue {
  @Getter('user') getUser: any
  @Action('setEduInfo') setEduinfo: any;
  layoutData: { name: string; list: IService[] }[] = [];
  userPoints = 0

  get orgId() {
    return this.$store.state.user?.orgs[0]?.orgId || 0;
  }

  // 判断当前是否为工具服务页面
  get isToolService() {
    return this.$route.path.includes('service_by_tool')
  }

  async created() {
    let entries = [0, 2, 3, 5, 9];
    let OrgInfo;
    if (!this.$store.state.stage) {
      OrgInfo = await getOrgInfoByOId({ orgId: this.orgId });
      this.$store.state.OrgInfo = OrgInfo;
    } else {
      OrgInfo = this.$store.state.OrgInfo;
    }
    if (!this.$store.state.stage) this.$store.state.stage = await getStage({});
    if (!this.$store.state.subject) this.$store.state.subject = await getSubject({});
    if (OrgInfo.entries && OrgInfo.entries.length)
      entries = OrgInfo.entries.split(',').map((item: string) => Number(item))

    // 根据路由选择不同的服务列表
    const serviceSource = this.isToolService ? serviceByToolList : serviceList
    this.layoutData = serviceSource
      .map(item => {
        return {
          name: item.name,
          list: item.list.filter(serve => entries.includes(serve.service_content)),
        }
      })
      .filter(l => l.list.length)

    await this.getEduInfo()

    // 如果是工具服务页面，获取用户点数
    if (this.isToolService) {
      this.userPoints = this.getUser?.orgs?.[0].wordPoints || 0
    }
  }

  async getEduInfo() {
    const storage = window.localStorage;
    try {
      const localSubject = JSON.parse(storage.getItem('subject') as string);
      const localStage = JSON.parse(storage.getItem('stage') as string);
      const localGrade = JSON.parse(storage.getItem('grade') as string);
      if (
        isArray(localSubject) &&
        isArray(localStage) &&
        isArray(localGrade) &&
        localSubject.length &&
        localStage.length &&
        localGrade.length
      ) {
        this.setEduinfo({
          subject: localSubject,
          grade: localGrade,
          stage: localStage
        });
        return;
      } else {
        throw new Error('get eduInfo');
      }
    } catch (error) {
      const [subject, stage, grade] = await Promise.all([getSubject({}), getStage({}), getGrade({})])
      if (
        !storage.getItem('subject') ||
        storage.getItem('subject') === 'null' ||
        storage.getItem('subject') === 'undefined' ||
        !storage.getItem('subject')?.length
      ) {
        storage.setItem('subject', JSON.stringify(subject))
      }
      if (
        !storage.getItem('stage') ||
        storage.getItem('stage') === 'null' ||
        storage.getItem('stage') === 'undefined' ||
        !storage.getItem('stage')?.length
      ) {
        storage.setItem('stage', JSON.stringify(stage))
      }
      if (
        !storage.getItem('grade') ||
        storage.getItem('grade') === 'null' ||
        storage.getItem('grade') === 'undefined' ||
        !storage.getItem('grade')?.length
      ) {
        storage.setItem('grade', JSON.stringify(grade))
      }
      this.setEduinfo({
        subject,
        grade,
        stage,
      });
    }
  }
  handleServieClick(service: IService) {
    // 如果是智能服务页面，需要判断用户点数
    if (this.isToolService && this.userPoints <= 0 && service.usePoints) {
      this.$message.error('该服务为自动扣费服务，另外联系客户经理进行充值或添加试用点数')
      return
    }

    window.sessionStorage.setItem('service_type', service.mapKey);
    window.sessionStorage.setItem('service_name', service.name);
    this.$router.push({
      name: 'create',
      params: {
        serviceType: service.mapKey,
        name: service.name,
        from: this.isToolService ? 'service_by_tool' : 'service'
      },
    });
  }
};
